import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BaseState, BaseEntity } from '@m4u-angular/base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { Component, Input } from '@angular/core';
import { EnumLanguages, EnumPageDisplayModes } from '@m4u-angular/core/framework/sysenums.enum';
import { SendDocumentParams } from '@dato-proxy/params/senddocument.param';
import { EnumDeliveryMethods, EnumEntityTypes } from '@dato-proxy/enums';
import { SystemOptionEndpoint } from '@dato-proxy/endpoints/systemoption.endpoint';

class State extends BaseState {
    DocumentNumber: number;
    Email: string;
    DeliveryMethod: EnumDeliveryMethods;
}
@Component({
    providers: ServiceBagServices,
    selector: 'app-test-options-dialog',
    templateUrl: './test-options-dialog.component.html',
    styleUrls: ['./test-options-dialog.component.scss']
})
export class TestOptionsDialogComponent extends BasePageComponent<BaseEntity, State> {

    @Input() DocumentTypeName: string;
    @Input() DocumentType: EnumEntityTypes;
    @Input() Language: EnumLanguages;

    constructor(A: ServiceBagService,
        private systemOptionEndpoint: SystemOptionEndpoint) {
        super(A, 'TestOptionsDialogComponent', BaseEntity, State, EnumPageDisplayModes.Dialog);
    }

    protected override OnInitState(): void {
        this.validationGroup?.instance?.reset();
        this.State.DeliveryMethod = EnumDeliveryMethods.Email;
    }

    public OnOK() {
        const params = new SendDocumentParams();
        params.DocumentNumber = this.State.DocumentNumber;
        params.Email = this.State.Email;
        params.DeliveryMethod = this.State.DeliveryMethod;
        params.EntityType = this.DocumentType;
        params.IsHebrew = this.Language === EnumLanguages.Hebrew;

        this.Do(this.systemOptionEndpoint.SendDocument(params), true, () => this.CloseDialogWithSuccess());
    }

    public GetDocumentNumberLabel() {
        return this.RC('lblDocumentNumber').replace('{0}', this.DocumentTypeName);
    }

}
